import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function UpsellSection() {
  return <section className="py-14 bg-zinc-950 relative border-t border-zinc-900 overflow-hidden" data-id="element-555">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(245,158,11,0.05)_0%,transparent_70%)]" data-id="element-556"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-557">
        <FadeIn data-id="element-558">
          <div className="text-center mb-12" data-id="element-559">
            <span className="text-5xl block mb-6" data-id="element-560">⚡</span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-561">
              UN MOMENTO — ANTES DE CONFIRMAR TU COMPRA
            </h2>
            <p className="text-xl md:text-2xl text-brand-amber font-bold" data-id="element-562">
              Agregá esto a tu pack y completá el sistema en un solo paso
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-563">
          <div className="space-y-6 text-lg text-zinc-300 mb-10" data-id="element-564">
            <p data-id="element-565">
              El Master Pack de 5 Tomos te da los protocolos para reparar
              cualquier falla.
            </p>
            <p data-id="element-566">
              Pero ¿quién te dice exactamente qué hacer cada semana para que
              esas fallas no ocurran? ¿Dónde conseguir cada repuesto en tu
              ciudad al menor precio posible? ¿Y cómo organizar todo el
              mantenimiento del año sin olvidarte nada?
            </p>
            <p className="font-bold text-white" data-id="element-567">
              Aprendiste a reparar. Tenés el sistema para actuar cuando algo
              falla.
            </p>
            <p data-id="element-568">
              Y sin embargo... a los 3 meses el tornillo del plegado volvió a
              aflojarse. O la batería se deterioró antes de tiempo porque la
              cargabas mal sin saberlo. O pinchaste de nuevo porque no sabías
              que había que inyectar Slime preventivo.
            </p>
            <p className="text-xl text-brand-amber font-bold mt-8" data-id="element-569">¿Por qué?</p>
            <p className="text-xl text-white font-bold" data-id="element-570">
              Porque dominar la reparación y dominar la prevención son dos cosas
              distintas.
            </p>
            <p data-id="element-571">Y la mayoría de los usuarios solo tiene acceso a una.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-572">
          <div className="bg-gradient-to-b from-zinc-900 to-zinc-950 border border-brand-amber/30 rounded-2xl p-8 md:p-10 shadow-[0_0_40px_rgba(245,158,11,0.1)] relative" data-id="element-573">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-amber text-zinc-950 font-bold px-6 py-2 rounded-full text-sm tracking-widest uppercase flex items-center gap-2 shadow-lg" data-id="element-574">
              <span data-id="element-575">🏆</span> COMPLETÁ TU PACK CON:
            </div>

            <div className="text-center mt-6 mb-10" data-id="element-576">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-577">
                MANTENIMIENTO PREVENTIVO EXPRESS
              </h3>
              <p className="text-xl text-brand-amber font-medium" data-id="element-578">
                El Sistema de 15 Minutos por Semana para el Monopatín que Nunca
                Falla
              </p>
            </div>

            <div className="space-y-8" data-id="element-579">
              <div className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800/50" data-id="element-580">
                <h4 className="text-xl font-bold text-white mb-3 flex items-center gap-3" data-id="element-581">
                  <span className="text-brand-amber" data-id="element-582">⏱️</span> Rutina Semanal de
                  15 Minutos
                </h4>
                <p className="text-zinc-400" data-id="element-583">
                  Los 5 puntos que verificás en 2 minutos antes de cada salida,
                  la rutina completa del domingo de 10 minutos y el chequeo
                  profundo trimestral conectado con los 5 tomos. En 15 minutos
                  por semana prevenís el 80% de las fallas antes de que ocurran.
                </p>
              </div>

              <div className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800/50" data-id="element-584">
                <h4 className="text-xl font-bold text-white mb-3 flex items-center gap-3" data-id="element-585">
                  <span className="text-brand-amber" data-id="element-586">📍</span> Directorio de
                  Repuestos Inteligentes Argentina
                </h4>
                <p className="text-zinc-400" data-id="element-587">
                  Dónde conseguir cada repuesto en Buenos Aires, Córdoba,
                  Mendoza y Rosario al menor precio posible. Las equivalencias
                  exactas entre repuestos originales caros y alternativas de
                  ferretería o bicicletería que cuestan un 60-80% menos. Los 5
                  repuestos que siempre hay que tener en casa como stock de
                  emergencia.
                </p>
              </div>

              <div className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800/50" data-id="element-588">
                <h4 className="text-xl font-bold text-white mb-3 flex items-center gap-3" data-id="element-589">
                  <span className="text-brand-amber" data-id="element-590">📅</span> Agenda de
                  Mantenimiento 12 Meses
                </h4>
                <p className="text-zinc-400" data-id="element-591">
                  El planificador anual completo con el calendario mes a mes,
                  las alertas estacionales, el registro de kilómetros, el log de
                  reparaciones y los 4 recordatorios especiales del año
                  incluyendo el almacenamiento invernal y la reactivación de
                  primavera.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}